import { Action } from '@ngrx/store';
import { IJobsiteSalesArea } from '@cemex-core/cmx-api/models/jobsite-sales-areas/jobsite-sales-area';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { PaymentTerm, ProductOP } from '@cemex-core/cmx-api';

export const RESET = '[Payment terms] Reset';

export const LOAD_PAYMENT_TERMS_FROM_SALESAREAS = '[Payment terms] Load payment terms from sales area';
export const LOAD_PAYMENT_TERMS_FROM_SALESAREAS_COMPLETE =
  '[Payment terms] Load payment terms from sales area complete';

export const LOAD_PAYMENT_TERMS_FROM_PRODUCT = '[Payment terms] Load payment terms from product';
export const LOAD_PAYMENT_TERMS_OP_FROM_PRODUCT = '[Payment terms] Load payment terms from product';
export const LOAD_PAYMENT_TERMS_FROM_CONTRACT = '[Payment terms] Load payment terms from contract';
export const LOAD_PAYMENT_TERMS_FROM_PRODUCT_COMPLETE = '[Payment terms] Load payment terms from product complete';

export class PaymentTermsLoadFromSalesAreasAction implements Action {
  readonly type = LOAD_PAYMENT_TERMS_FROM_SALESAREAS;

  constructor(public payload: IJobsiteSalesArea[]) { }
}

export class PaymentTermsLoadFromSalesAreasCompleteAction implements Action {
  readonly type = LOAD_PAYMENT_TERMS_FROM_SALESAREAS_COMPLETE;

  constructor(public payload: PaymentTerm) { }
}

export class PaymentTermsLoadFromProductAction implements Action {
  readonly type = LOAD_PAYMENT_TERMS_FROM_PRODUCT;

  constructor(public payload: IProduct) { }
}

export class PaymentTermsULinkLoadFromProductAction implements Action {
  readonly type = LOAD_PAYMENT_TERMS_OP_FROM_PRODUCT;

  constructor(public payload: ProductOP) { }
}

export class PaymentTermsLoadFromContractAction implements Action {
  readonly type = LOAD_PAYMENT_TERMS_FROM_CONTRACT;

  constructor(public payload: { productId: number | string }) { }
}

export class PaymentTermsLoadFromProductCompleteAction implements Action {
  readonly type = LOAD_PAYMENT_TERMS_FROM_PRODUCT_COMPLETE;

  constructor(
    public payload: {
      productId: number | string;
      paymentTerms: PaymentTerm[];
    },
  ) { }
}

export class PaymentTermsResetAction implements Action {
  readonly type = RESET;

  constructor() { }
}

export type PaymentTermsActions =
  | PaymentTermsLoadFromSalesAreasAction
  | PaymentTermsLoadFromSalesAreasCompleteAction
  | PaymentTermsResetAction
  | PaymentTermsLoadFromProductAction
  | PaymentTermsLoadFromProductCompleteAction;
